<template>
  <div class="library-banner">
    <div class="container">
      <div class="flex-container justify-space-between align-items-center">
        <div class="flex-item grow title-container">
          <slot>
            <h1><i class="fa fa-folder header-folder" />&nbsp;{{ title }}</h1>
          </slot>
          <ul class="breadcrumb" v-if="breadcrumbs">
            <li>
              <router-link :to="{name: 'Home'}">Home</router-link>
            </li>
            <slot name="breadcrumbList" />
          </ul>
        </div>
        <div class="flex-item side-area">
          <slot name="buttons" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LibraryBanner',
  components: {},
  props: {
    title: {
      type: String,
      required: true
    },
    breadcrumbs: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="less" scoped>
@import '~@/variables.less';
.library-banner {
  background: @libraryColorBg;
  margin-top: -20px;
  margin-bottom: 2em;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
  a {
    color: @link-darker;
  }
}
.library-banner h1 {
  font-size: 32px;
  margin: 10px 0;
  max-width: 100%;
}
.header-folder {
  color: #d2c361;
}
.breadcrumb {
  background-color: transparent;
  padding-left: 0px;
  margin-bottom: 0;
}
.flex-item.title-container {
  margin-right: 8px;
}
</style>
